export default {
  email: (permalink, subject, description) => {
    const url = permalink || window.location.href
    const ga = window.ga;
    ga('send', 'social', 'Email', 'Email', url);
    window.open(
      `https://api.addthis.com/oexchange/0.8/forward/email/offer?url=${encodeURIComponent(url)}&title=${subject}&description=${description}`,
      'share',
      'status=no,toolbar=no,location=no,directories=no,menubar=no'
    )
  },

  facebook: (permalink) => {
    const url = permalink || window.location.href;
    const ga = window.ga;
    ga('send', 'social', 'Facebook', 'Share', url);
    if (window.FB) {
      window.FB.ui({
        method: 'share',
        href: url,
      })
    } else {
      window.open(
        `https://facebook.com/sharer.php?u=${encodeURIComponent(url)}`,
        'share',
        'status=no,toolbar=no,location=no,directories=no,menubar=no'
      )
    }
  },

  twitter: (permalink, title)=> {
    const url = permalink || window.location.hrefs
    const ga = window.ga;
    ga('send', 'social', 'Twitter', 'Tweet', url);
    var text = title
    window.open(
      `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`,
      'share',
      'status=no,toolbar=no,location=no,directories=no,menubar=no'
    )
  },

  whatsapp: (permalink, title) => {
    const url = permalink || window.location.href
    const ga = window.ga;
    ga('send', 'social', 'Whatsapp', 'Whatsapp', url);
    var text = title
    const encodedUrl = `whatsapp://send?text=${encodeURIComponent(text)}%20${encodeURIComponent(url)}`
    window.location = encodedUrl
  },

  googlePlus: (permalink) => {
    const url = permalink || window.location.href;
    const ga = window.ga;
    ga('send', 'social', 'GooglePlus', 'GooglePlus', url);
    window.open(
      `https://plus.google.com/share?url=${encodeURIComponent(url)}`,
      'share',
      'status=no,toolbar=no,location=no,directories=no,menubar=no'
    )
  }
}
